import moment from 'moment';
const regexCaracter = /^[a-zA-Z0-9]+$/;
const CryptoJS = require('crypto-js');

export const Encrypt = (data, key) => CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();

export const Decrypt = (data, key) => {
  const bytes = CryptoJS.AES.decrypt(data.toString(), key);

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const doTruncateText = (text, limit) => {
  if (text.length < limit || text === null) return text;

  limit--;
  let last;

  last = text.substr(limit - 1, 1);

  while (last !== ' ' && limit > 0) {
    limit--;
    last = text.substr(limit - 1, 1);
  }

  last = text.substr(limit - 2, 1);

  if (last == ',' || last == ';' || last == ':') return text.substr(0, limit - 2) + '...';

  if (last == '.' || last == '?' || last == '!') return text.substr(0, limit - 1);

  return text.substr(0, limit - 1) + '...';
};

export const getTimeZone = () => {
  var offset = new Date().getTimezoneOffset(),
    o = Math.abs(offset);
  return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2);
};

export const typeDecimal = (value, schema) => {
  if (typeof value == 'number') {
    let currencySymbol = 'R$';

    let number = parseFloat(value)
      .toFixed(2)
      .split('.');
    number[0] = number[0].split(/(?=(?:...)*$)/).join('.');

    return currencySymbol + ' ' + number.join(',');
  }

  return value;
};

export const typeZipCode = value => {
  if (regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.length == 8) {
      let regex = /([0-9]{5})([0-9]{3})/;
      let valueSplit = regex.exec(valueString);

      return valueSplit[1] + '-' + valueSplit[2];
    }
  }

  return value;
};

export const typePhone = value => {
  if (regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length == 10) {
      let regex = /([0-9]{2})([0-9]{4})([0-9]{4})/;
      let valueSplit = regex.exec(valueString);

      return '(' + valueSplit[1] + ') ' + valueSplit[2] + '-' + valueSplit[3];
    } else if (valueString.toString().length == 11) {
      let regex = /([0-9]{2})([0-9]{5})([0-9]{4})/;
      let valueSplit = regex.exec(valueString);

      return '(' + valueSplit[1] + ') ' + valueSplit[2] + '-' + valueSplit[3];
    }
  }

  return value;
};

export const typeCpf = value => {
  if (regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length == 11) {
      let regex = /(\d{3})(\d{3})(\d{3})(\d{2})$/;
      let valueSplit = regex.exec(valueString);

      return valueSplit[1] + '.' + valueSplit[2] + '.' + valueSplit[3] + '-' + valueSplit[4];
    }
  }

  return value;
};

export const typeCNPJ = value => {
  if (regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length == 14) {
      let regex = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g;
      let valueSplit = regex.exec(valueString);

      return valueSplit[1] + '.' + valueSplit[2] + '.' + valueSplit[3] + '/' + valueSplit[4] + '-' + valueSplit[5];
    }
  }

  return value;
};

export const typePercentageSymbol = value => {
  if (/\d */g.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length > 0) {

      let valueSplit = valueString.replace(/[ÁÉÍÓÚáéíóúâêîôûàèìòùÇçãõ/.,~!@#$%&_-]*/g, "").replace(/[a-z-A-Z]*/g, "")

      return valueSplit + '%';
    }
  }

  return value;
};

export const formatEntry = entry => {
  let redirect = {};
  entry
    .replace(/'/g, '')
    .split(';')
    .forEach(element => {
      redirect[element.split('=')[0].trim()] = element.split('=')[1];
    });

  return redirect;
};

export const isReport = query => query.hasOwnProperty('procedure') && query.hasOwnProperty('id_dashboard');

const b64toBlob = (b64Data, contentType, sliceSize) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: contentType
  });

  return blob;
};

export const downloadFile = (data, contentType, extension, fileName) => {
  const blob = b64toBlob(data, contentType, 512);
  const blobUrl = window.URL.createObjectURL(blob);

  let tag = document.createElement('a');
  tag.className = 'download-file';
  tag.style = 'display: none';
  tag.href = blobUrl;
  tag.download = fileName ? `${fileName}.${extension}` : `file-${new Date().getTime()}.${extension}`;

  document.body.appendChild(tag);
  tag.click();
  window.URL.revokeObjectURL(blobUrl);
  document.getElementsByClassName('download-file')[0].remove();
};

export const formatValue = (schema, value) => {
  const types = ['date', 'dateTime', 'decimal', 'zipcode', 'phone', 'phone', 'cpf', 'cnpj', 'percentageSymbol']

  if (types.indexOf(schema.type) >= 0) {
    return {
      date: value => moment(value).format('DD/MM/YYYY'),
      dateTime: value => moment(value).format('DD/MM/YYYY h:mm:ss'),
      decimal: value => typeDecimal(value, schema),
      zipcode: value => typeZipCode(value),
      phone: value => typePhone(value),
      cpf: value => typeCpf(value),
      cnpj: value => typeCNPJ(value),
      percentageSymbol: value => typePercentageSymbol(value)
    }[schema.type](value);
  }
};

export const getIcon = type => {
  let icons = {
    'application/pdf': 'fas fa-file-pdf',
    'image/jpeg': 'far fa-file-image',
    'image/png': 'far fa-file-image',
    'image/gif': 'far fa-file-image',
    'application/vnd.ms-excel': 'far fa-file-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'far fa-file-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'far fa-file-word',
    'application/x-zip-compressed': 'far fa-file-archive',
    default: 'far fa-file'
  };
  return icons[type] || icons['default'];
};

export const formatBytes = bytes => {
  bytes = bytes * 1000;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};
